export default "__VITE_ASSET__BD1Op4vY__"